import { useEffect, useMemo, useRef } from 'react'
import { connect } from 'react-redux'
import {
  STATIC_NAV_ENTRIES,
  buildDynamicNavigationEntries,
  buildNavigationFuseIndex,
  searchNavigation,
} from '../local/navigationRegistry'

/**
 * Headless additive search provider for in-app navigation.
 *
 * Combines a curated static route table with Redux-derived dynamic entries
 * (sections — one per class) into a single Fuse index. Packs are excluded
 * from navigation results; they appear in the Library search instead.
 * Results are routed to SupplementarySearchContext under providerId='navigation'.
 *
 * Each emitted hit shape:
 *   { id, label, path, icon, keywords,
 *     objectID, __nav: true, __localOrigin: true }
 *
 * The UI is expected to discriminate via __nav and route via history.push(path).
 */
function NavigationSearchProvider({
  query, options, onResults,
  sections,
}) {
  const entries = useMemo(
    () => STATIC_NAV_ENTRIES.concat(
      buildDynamicNavigationEntries({ sections }),
    ),
    [sections],
  )

  const fuse = useMemo(() => buildNavigationFuseIndex(entries), [entries])

  const onResultsRef = useRef(onResults)
  onResultsRef.current = onResults

  useEffect(() => {
    if (!query) {
      onResultsRef.current({ hits: [] })
      return
    }
    const limit = options && options.hitsPerPage ? options.hitsPerPage : 8
    const hits = searchNavigation(fuse, query, limit)
    onResultsRef.current({ hits })
    // eslint-disable-next-line no-console
    console.log('[local-search:navigation]', {
      query, limit, hitCount: hits.length, hits,
    })
  }, [query, fuse, options])

  return null
}

function mapStateToProps(state) {
  return {
    sections: state.sections,
  }
}

export default connect(mapStateToProps)(NavigationSearchProvider)
